export const BLOG_CATEGORY_ORDER = ["language-guide", "new-features", "company-updates"] as const;

export function toLanguageArchiveSlug(language: string): string {
  return language
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function fromLanguageArchiveSlug(slug: string, languages: string[]): string | undefined {
  return languages.find((language) => toLanguageArchiveSlug(language) === slug);
}

export function toIsoDate(date: string): string {
  if (!date) return new Date().toISOString();
  return new Date(`${date}T00:00:00.000Z`).toISOString();
}
